import React from 'react';
import styles from './two_columns_articles_list_bs5.module.scss';
import { NEWS_PATH } from '../../../src/utilities/devex_paths';
import chunk from 'lodash/chunk';
import classNames from 'classnames';
import { formatDistanceToNow } from 'date-fns';

const CLOUDINARY_PATH =
  'https://res.cloudinary.com/devex/image/fetch/c_fill,f_auto,h_250,q_auto,w_516';

interface Article {
  id: number;
  slug_and_id: string;
  title: string;
  thumbnail: string;
  teaser?: string;
  publication_date?: string;
  is_evergreen?: boolean;
  overline?: string;
}

const TwoColumnsArticlesListBs5: React.FC<{
  list: Article[];
  showColBorderOnDesktop: boolean;
  showAdditionalDetails: boolean;
}> = ({ list, showColBorderOnDesktop, showAdditionalDetails }) => {
  const chunks = chunk(list, 2);

  const renderArticleAdditionalDetails = (article: Article): React.ReactNode => {
    const details = [];
    if (article.publication_date && !article.is_evergreen) {
      details.push(formatDistanceToNow(new Date(article.publication_date), { addSuffix: true }));
    }
    if (article.overline) {
      details.push(article.overline);
    }

    if (!details.length) return null;
    return <p className='fst-italic fs-7'>{details.join(' // ')}</p>;
  };

  return (
    <div className={styles.wrapper}>
      <div className='articles-list-d9e94381-a7e4-48e8-a383-3b2ee676f1c9'>
        {
          chunks.map((rowsOf2Articles: Article[], index: number) => (
            <div className='row' key={index}>
              {rowsOf2Articles.map(
                (article: Article, idx: number): React.ReactNode => (
                  <div
                    className={classNames(
                      'col-12 col-md-6 pt-35 horizontal-border-between-articles',
                      { 'vertical-border-between-cols': showColBorderOnDesktop && idx === 0 },
                    )}
                    key={article.id}
                  >
                    <div className='card border-0'>
                      <figure>
                        <img
                          className='w-100 img-fluid bordered'
                          loading='lazy'
                          src={`${CLOUDINARY_PATH}/${article.thumbnail}`}
                          alt={article.title || 'Image of the article'}
                        />
                      </figure>
                      <div className='card-body px-1 pb-1'>
                        <h3 className='card-title fs-55 fw-bold'>
                          <a
                            className='link-gray-blue stretched-link'
                            href={`${NEWS_PATH}/${article.slug_and_id}`}
                          >
                            {article.title}
                          </a>
                        </h3>
                        <div className='card-text'>
                          {showAdditionalDetails && renderArticleAdditionalDetails(article)}
                          {article.teaser && <p>{article.teaser}</p>}
                        </div>
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          ))
        }
      </div>
    </div>
  );
};

export default TwoColumnsArticlesListBs5;
